// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function(){
  Certifications.Modals.EditorWelcomeModalIntro = createReactClass({

    getInitialState: function() {
      return {
        interested: true,
        accepted: false,
        submitted: false
      }
    },

    render: function() {
      var failure = '';
      if(this.state.accepted === false && this.state.submitted === true){
        failure = this.renderFailureMessage()
      }
      return (
        <div>
          <p className="u-tcGrayDarkest u-fw700 u-fs18 u-lineHeight1 u-mb4x">
            Congratulations!
          </p>
          <p className="u-tcGrayDarkest u-fs14 u-fw400 u-lineHeigh1_4 u-mb5x">
            You&#39;re invited to join the endorser program because one of your papers
            was recommended. Recommending papers provides exposure to authors
            who deserve credit.
          </p>
          {failure}
          <p className="u-tcGrayDarkest u-fs14 u-fw400 u-lineHeigh1_4 u-mb6x">
            <input
              type="checkbox"
              className="u-floatLeft"
              onChange={this.toggleAccept}
            />
            <span className="u-displayBlock u-ml6x">
              I agree to be an endorser, and understand that I am expected to
              recommend 2-4 papers per month.
            </span>
          </p>
          <button
            className="Button Button--md Button--green u-mr4x"
            type="submit"
            onClick={this.handleSubmit}
          >
            RECOMMEND A PAPER
          </button>
          <a
            className="u-tcGrayDark u-fw500 u-verticalAlignMiddle u-fs12"
            style={{lineHeight:"44px"}}
            onClick={this.handleDisinterested}
            href="#"
          >
            Not Interested
          </a>
        </div>
      );
    },

    toggleAccept: function() {
      this.setState({accepted: !this.state.accepted});
    },

    handleDisinterested: function() {
      Aedu.Dismissibles.recordDismissal("EditorUnibrow");
      window.location = $r.home_url();
    },

    handleSubmit: function() {
      if(this.state.accepted) {
        $.ajax({
          type: "PATCH",
          url: $r.api_v0_user_certification_permissions_path({user_id: 'current user', subdomain_param: 'api'})
        }).done(this.cleanUpSubmit);
      } else {
        this.setState({submitted: true});
      }
    },

    cleanUpSubmit: function() {
      Aedu.Dismissibles.recordDismissal("EditorModal");
      Aedu.Dismissibles.recordDismissal("EditorUnibrow");
      $("[data-dismiss=modal]").trigger({ type: "click" });
    },

    renderFailureMessage: function() {
      return (
        <p className="u-fs12 u-fw500 u-tcRed">
          Please agree to the terms to continue
        </p>
      )
    },

  });
})();
